<p-table [value]="territoryConfig" [scrollable]="true">
    <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
            <td class="p-col-12">Enable Territory <span style="color:red;font-weight: bold;">*</span></td>
            <td class="p-col-2 action p-text-right" style="display: inline-block;">
                <p-button
                    (click)="enableDisableTerritory(data, 'disabled')"
                    icon="pi pi-check"
                    label="Yes"
                    *ngIf="data?.isTerritoryManagementEnabled"
                ></p-button>
                <p-button
                    (click)="enableDisableTerritory(data, 'enabled')"
                    icon="pi pi-times"
                    label="No"
                    *ngIf="!data?.isTerritoryManagementEnabled"
                ></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>

<div>
    <p class="p-col-12"><span style="color:red;font-weight: bold;">*</span> {{enableTerritoryWarningMsg}}</p>
</div>

<!-- <div *ngIf="showJobfunctionTable" class="p-d-flex p-jc-between p-mt-2 p-py-3" style="border-top: 1px solid #eee;">
    <div class="p-ml-3">
        Show Account Owner
    </div>
    <p-selectButton [options]="stateOptions" [(ngModel)]="stateValue" optionLabel="label" optionValue="value"></p-selectButton>
</div> -->

<p-table [value]="jobFunctionListInConfig" responsiveLayout="scroll" 
*ngIf="showJobfunctionTable" [rows]="15" [paginator]="true">
    <!-- <ng-template pTemplate="caption">
        <div class="p-d-flex p-jc-between">
            <div class="p-field-checkbox p-mb-0">
                <p-checkbox 
                    [(ngModel)]="checkLeadAndAccountOwner" 
                    [binary]="true" 
                    inputId="binary" 
                    (onChange)="checkUncheckLeadAndAccountOwner($event)">
                </p-checkbox>
                <label for="binary">Lead and Account owner same as Territory contact</label>
            </div>
            <p-button label="Save" *ngIf="showSaveBtn" (click)="saveLeadAndAccountOwnerChange()"></p-button>
        </div>
    </ng-template> -->
    <ng-template pTemplate="header">
        <tr>
            <th>Job Function</th>
            <th>Is Active</th>
            <th class="action p-text-right" style="width: 100px;">
                <p-button icon="pi pi-plus" (click)="getJobFunctionLists()"></p-button>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <td>{{data?.jobTypeName}}</td>
            <td>
                {{data?.isActive ? 'Yes' : 'No'}}
            </td>
            <td></td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Job Function Lists" [(visible)]="displayJobFunctionModal" [modal]="true" [responsive]="true" 
[style]="{width: '60vw'}">
    <div class="card">
        <p-table #jobFunctionTable [value]="jobFunctionList" responsiveLayout="scroll" [rows]="15" [paginator]="true" 
        selectionMode="multiple" [(selection)]="selectedJobTypes" dataKey="id">
            <ng-template pTemplate="header">
                <tr>
                    <th>Job Function Name</th>
                    <td>Associated User</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
                <tr [pSelectableRow]="data" [pSelectableRowIndex]="rowIndex">
                    <td>{{data.name}}</td>
                    <td>{{data?.noOfAssociatedUsers}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
  <p-footer>
    <button type="button" pButton (click)="cancelJobFunctionModal()" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton label="Save" (click)="saveJobFunction()"></button>
  </p-footer>
</p-dialog>